import React, { forwardRef } from 'react';
import clsx from 'clsx';

import { NavbarLeft } from './NavbarLeft';
import { NavbarCenter } from './NavbarCenter';
import { NavbarRight } from './NavbarRight';

import { Divider } from '../Divider';

import styles from './Navbar.module.scss';
import { StandardProps } from '../../types/common';

interface NavbarProps extends StandardProps {
  /**
   * Type is primary or secondary
   */
  type?: 'primary' | 'secondary';

  /**
   * maxWidth from parent
   */
  maxwidth?: string;
}

const NavbarComponent = forwardRef<HTMLDivElement, NavbarProps>(
  (
    {
      children,
      className,
      maxwidth,
      style,
      type,
      testid = `${type}-navbar`,
      ...props
    },
    ref
  ) => {
    const addstyles = {
      maxWidth: maxwidth,
      style,
    };
    return (
      <>
        {type === 'secondary' && <Divider />}
        <div
          ref={ref}
          id={`${type}-navbar`}
          className={clsx(
            styles['hds-navbar'],
            {
              [styles['hds-navbar__primary']]: type === 'primary',
              [styles['hds-navbar__secondary']]: type === 'secondary',
            },
            'container',
            className
          )}
          style={addstyles}
          data-testid={testid}
          {...props}
        >
          {children}
        </div>
      </>
    );
  }
);

export const Navbar =
  NavbarComponent as unknown as React.ForwardRefExoticComponent<
    NavbarProps & React.RefAttributes<HTMLDivElement>
  > & {
    Center: typeof NavbarCenter;
    Left: typeof NavbarLeft;
    Right: typeof NavbarRight;
  };

Navbar.Left = NavbarLeft;
Navbar.Center = NavbarCenter;
Navbar.Right = NavbarRight;
